export class InvalidAccessTokenError extends Error {
  constructor(message) {
    super(message);
  }
}

